export default __webpack_public_path__ + "static/media/bot.c9a1415e.png";